module.exports = __webpack_public_path__ + "img/cms-list-grid.24dd7a92.svg";